import { useState, useLayoutEffect } from 'react';
import { useRef } from 'react';
import { twMerge } from '@belong/common';
import { Button, Text } from '@belong/ui';

type ClampedTextProps = {
  description: string;
};

export function ClampedText({ description }: ClampedTextProps) {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isClamped, setIsClamped] = useState(true); // Set initial value to true, assuming it's clamped
  const [canBeClamped, setCanBeClamped] = useState(true);

  useLayoutEffect(() => {
    const spanElement = textRef.current;
    if (spanElement) {
      const canBeClamped = spanElement.scrollHeight > spanElement.clientHeight;
      setCanBeClamped(canBeClamped);
    }
  }, []);

  return (
    <div className="flex h-auto flex-col overflow-hidden">
      <Text
        style={{ maxHeight: !isClamped ? textRef.current?.scrollHeight : 48 }}
        ref={textRef}
        className={twMerge(
          'whitespace-pre-wrap mr-lg transition-all ease-in-out duration-hover mb-xl',
          isClamped ? 'line-clamp-2' : '',
        )}
      >
        {description}
      </Text>

      {canBeClamped && (
        <Button
          className="self-end"
          variant="text"
          onClick={() => setIsClamped((prevState) => !prevState)}
        >
          {isClamped ? 'SEE MORE' : 'SEE LESS'}
        </Button>
      )}
    </div>
  );
}
